import type { PlayerHost } from '@knolskape/educate-components';
import type { EducateModule } from '@/hooks/useEducateModule';
import { buildPlayerHost } from './moduleHost';
import { resolveUiConfig, positionalMapper, identityMapper } from './uiConfig';

export interface ProductHostProps {
  config: unknown;
  content: unknown;
  host: PlayerHost;
  storylineId: string;
}

/**
 * Assembles everything a shared-renderer product needs from the 4e module:
 * the uiConfig, content, and a PlayerHost wired to 4e persistence + completion.
 * Returns null when the storyline or its uiConfig isn't available yet.
 */
export const useProductHost = (
  module: EducateModule,
  options?: { identity?: boolean }
): ProductHostProps | null => {
  const { storyline, units, finishModule } = module;
  if (!storyline) return null;
  const config = resolveUiConfig(storyline);
  if (!config) return null;
  const host = buildPlayerHost({
    storylineId: storyline.storylineId,
    onComplete: finishModule,
    mapUnitId: options?.identity ? identityMapper : positionalMapper(units.map((unit) => unit.id))
  });
  return { config, content: storyline.content, host, storylineId: storyline.storylineId };
};
